import React, { useState } from "react";
import styles from "./Purchase.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import lock from "../../assets/images/lock.png";
import box from "../../assets/images/box.png";
import { useNavigate } from "react-router-dom";
const PurchaseHistoryMain = () => {
  const data = [0, 1, 2];
  const data1 = [0];
  const navigate = useNavigate();
  const [toggle1, setToggle1] = useState(true);
  const [toggle2, setToggle2] = useState(false);
  const button1Click = () => {
    setToggle1(true);
    setToggle2(false);
  };
  const button2Click = () => {
    navigate("/top");
  };
  return (
    <div>
      <Header />
      <div className={styles.purchase}>
        <h6 className={styles.purchaseTitle}>履歴確認</h6>
        <div className={styles.purchase_content}>
          <div className="d-flex">
            <h6
              onClick={button1Click}
              className={toggle1 ? `${styles.button1}` : `${styles.button11}`}
            >
              <img src={lock} alt="" /> 購入履歴
            </h6>
            <h6
              onClick={button2Click}
              className={toggle2 ? `${styles.button22}` : `${styles.button2}`}
            >
              <img src={box} alt="" /> 購入履歴
            </h6>
          </div>
          <hr className={styles.hr} />
          <table>
            {data &&
              toggle1 &&
              Array.isArray(data) &&
              data.length > 0 &&
              data.map((d, i) => (
                <>
                  <tr>
                    <td>
                      <p>
                        購入日 <span className={styles.date}>2022/12/18</span>
                      </p>
                    </td>
                    <td>
                      <p>
                        点数 <span className={styles.date}>4</span>
                      </p>
                    </td>
                    <td>
                      <p>
                        商品合計金額
                        <span className={styles.date}>￥41,730</span>
                      </p>
                    </td>
                    <td
                      onClick={() => {
                        console.log(data);
                      }}
                    >
                      <p className={styles.details}>詳細</p>
                    </td>
                  </tr>
                  <hr className={styles.hr2} />
                </>
              ))}
            {data1 &&
              toggle2 &&
              Array.isArray(data1) &&
              data1.length > 0 &&
              data1.map((d, i) => (
                <>
                  <div className="d-flex">
                    <div className={styles.datelbl}>
                      <h6>ご来店日</h6>
                    </div>
                    <div className={styles.hdate}>
                      <h6>2022/12/18</h6>
                    </div>
                    <div className={styles.studio}>
                      <h6>スタジオ</h6>
                    </div>
                    <div className={styles.address}>
                      <h6>鳥飼八幡宮点別館1003</h6>
                    </div>
                    <div className={styles.plan}>
                      <h6>プラン</h6>
                    </div>
                    <div className={styles.planDetails}>
                      <h6>ハーフバースデープラン</h6>
                    </div>
                  </div>
                  <hr className={styles.hr5} />
                </>
              ))}
          </table>
        </div>
        <div
          onClick={() => {
            navigate("/top");
          }}
          className={styles.return}
        >
          <h6>戻る</h6>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PurchaseHistoryMain;
